import { startTransition, useCallback } from "react";
function useShallowSetState(setter, debug, debugName) {
  return useCallback(
    (next) => {
      const shouldTransition = Object.keys(next).every(
        (k) => transitionKeys.has(k)
      );
      const run = shouldTransition ? startTransition : (_) => _();
      run(() => {
        setter((prev) => {
          for (const key in next) {
            if (prev[key] !== next[key]) {
              if (process.env.NODE_ENV === "development" && debug === "verbose") {
                console.log(` \u25B2 setState ${debugName}`, next);
              }
              return { ...prev, ...next };
            }
          }
          return prev;
        });
      });
    },
    [setter]
  );
}
const transitionKeys = /* @__PURE__ */ new Set([
  "press",
  "pressIn",
  "focus",
  "unmounted"
]);
export {
  useShallowSetState
};
//# sourceMappingURL=useShallowSetState.js.map
